module.exports = __webpack_public_path__ + "img/sign-60.57baa997.jpg";